module.exports = __webpack_public_path__ + "images/110_320.jpg";